"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSearchToJSON = exports.FilterSearchFromJSONTyped = exports.FilterSearchFromJSON = exports.instanceOfFilterSearch = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FilterSearch interface.
 */
function instanceOfFilterSearch(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFilterSearch = instanceOfFilterSearch;
function FilterSearchFromJSON(json) {
    return FilterSearchFromJSONTyped(json, false);
}
exports.FilterSearchFromJSON = FilterSearchFromJSON;
function FilterSearchFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'n': !(0, runtime_1.exists)(json, 'n') ? undefined : json['n'],
        'e': !(0, runtime_1.exists)(json, 'e') ? undefined : json['e'],
        'v': !(0, runtime_1.exists)(json, 'v') ? undefined : json['v'],
    };
}
exports.FilterSearchFromJSONTyped = FilterSearchFromJSONTyped;
function FilterSearchToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'n': value.n,
        'e': value.e,
        'v': value.v,
    };
}
exports.FilterSearchToJSON = FilterSearchToJSON;
